import {APIClient} from '@wharfkit/antelope'
import { create } from "ipfs-http-client";
import configuration from './configuration.json';

export async function checkBCEndpoint() {
    // On HTTPS pages the only way to reach a plain-HTTP Antelope node
    // from the browser is via a same-origin proxy. Nginx is configured
    // to route `/chain/*` to the actual node. Try that FIRST. Also
    // filter the configured endpoints to match the page's protocol —
    // HTTP-only on HTTP pages, HTTPS-only on HTTPS pages — so the dev
    // console doesn't get spammed with mixed-content / CORS errors
    // from endpoints that can't possibly succeed in this environment.
    //
    // Mirrors paper-reviewer's `nodeUrl: ${window.location.origin}/chain`
    // pattern (see paper-reviewer/frontend/src/config/blockchain.ts).
    const isHttps = typeof window !== 'undefined'
        && window.location.protocol === 'https:';
    const wantScheme = isHttps ? 'https:' : 'http:';
    const candidates = [];
    if (isHttps) {
        candidates.push(`${window.location.origin}/chain`);
    }
    candidates.push(
        ...configuration.passer.BCEndPoints
            .map(item => item.url)
            .filter(u => (u || '').startsWith(wantScheme))
    );
    for (let i = 0; i < candidates.length; i++) {
        const ch = new APIClient({ url: candidates[i] });
        try {
            await ch.v1.chain.get_info();
            return candidates[i];
        } catch (err) {
            console.log("chain info error", err);
        }
    }
}

export async function checkIPFSEndpoint() {
    // const ipfs_epoints = configuration.passer.IPFSEndPoints.map(item => ({host: item.host, port: item.port}));
    // for (let i = 0; i < ipfs_epoints.length; i++) {
    //     const client = create({
    //         host: ipfs_epoints[i].host,
    //         port: ipfs_epoints[i].port,
    //         protocol: 'http'
    //     })
    //     try {
    //         const resp = client.isOnline();
    //         return ipfs_epoints[i];
    //     } catch (err) {
    //         console.log("ipfs info error", err);
    //     }
    // }
    return configuration.passer.IPFSEndPoints[1];
}